import _ from 'lodash'
import types from '@/store/mutation-types'
import * as postFitoutApi from '@/api/tenantProjects/postFitout.request'
import { POST_FITOUT_STATUS } from '@/modules/tenantProjects/postFitOutLetter/consts'
import { unref } from 'vue-demi'
import { forceUpdateVueObject } from '@/store/util'

/**
 * @typedef History
 * @prop {string} id
 * @prop {string} type
 * @prop {string} actionType
 * @prop {Date | string} createdAt
 * @prop {Object} createdBy
 * @prop {string} createdBy.id
 * @prop {string} createdBy.username
 * @prop {string} createdBy.displayName
 */
/**
 * @typedef Submission
 * @prop {string} id
 * @prop {string} createdAt
 * @prop {string} createdBy
 * @prop {string} updatedAt
 * @prop {string} managedBy
 * @prop {Object} manager
 * @prop {string} manager.displayName
 * @prop {string} manager.id
 * @prop {string} manager.title
 * @prop {string} manager.username
 * @prop {string} status
 * @prop {string} projectId
 * @prop {number} order
 * @prop {History[]} histories
 */
/**
 * @typedef State
 * @prop {Submission} underReviewPostFitout
 * @prop {Submission[]} postFitouts
 */
/**
 * @type {State}
 */
const defaultState = {
  underReviewPostFitout: {},
  postFitouts: [],
  pendingGuidelinesList: [],
}

const getters = {
  /** @param {State} state */
  underReviewPostFitout: (state) => state.underReviewPostFitout,
  pendingGuidelinesList: (state) => state.pendingGuidelinesList,
}

// actions
const actions = {
  /**
   * @param {VuexActionContext<State>} options
   * @param {OrRef<string | number>} projectId
   */
  async loadProjectPostFitoutSubmissions ({ commit }, projectId) {
    const result = await postFitoutApi.getProjectPostFitoutSubmissions({ projectId: unref(projectId) })
    commit(types.TP_POST_FITOUT_SUBMISSIONS, result)
    const underReviewItem = result.find(item => item.status === POST_FITOUT_STATUS.UNDER_REVIEW) || {}
    commit(types.TP_POST_FITOUT_UR_SUBMISSION, underReviewItem)
  },
  /**
   * @param {VuexActionContext<State>} options
   * @param {OrRef<string | number>} [id]
   */
  async getUnderReviewSubmission ({ commit, state }, id) {
    if (!id) id = state.underReviewPostFitout.id
    const result = await postFitoutApi.getPostFitoutSubmission(id)
    commit(types.TP_POST_FITOUT_UR_SUBMISSION, result)
    return result
  },

}

// mutations
const mutations = {
  [types.TP_POST_FITOUT_SUBMISSIONS] (state, value) {
    state.postFitouts = value
  },
  [types.TP_POST_FITOUT_UR_SUBMISSION] (state, value) {
    state.underReviewPostFitout = value
  },
  [types.TP_POST_FITOUT_UPDATE_FIELD_PATH] (state, { path, newValue }) {
    forceUpdateVueObject(state.underReviewPostFitout, path, newValue)
  },
  [types.TP_POST_FITOUT_UPDATE_PENDING_GUIDELINE] (state, value) {
    state.pendingGuidelinesList = value
  },
  [types.TP_POST_FITOUT_RESET] (state) {
    state.postFitouts = []
    state.underReviewPostFitout = {}
    state.pendingGuidelinesList = []
  },
}

export default {
  namespaced: true,
  state: _.cloneDeep(defaultState),
  getters,
  actions,
  mutations,
}
